import * as React from 'react';
import { useState, useEffect } from "react";
import axios from "axios";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { logout } from "../redux/actions/userActions.js";
import { useDispatch, useSelector } from "react-redux";
import { getCategories } from "../redux/actions/categoryActions.js";
import { setChatRooms, setSocket, setMessageReceived, removeChatRoom } from "../redux/actions/chatActions.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebook } from "@fortawesome/free-brands-svg-icons"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { faInstagramSquare } from "@fortawesome/free-brands-svg-icons"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"

import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

import Badge, { badgeClasses } from '@mui/material/Badge';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCartOutlined';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';

import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CheckIcon from '@mui/icons-material/Check';
import ListAltSharpIcon from '@mui/icons-material/ListAltSharp';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import socketIOClient from "socket.io-client";

import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import { themeResponsive } from "./../theme/responsiveTheme.js";

const responsiveTheme = responsiveFontSizes(themeResponsive);

const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -14px;
    right: -7px;
  }
`;

const config = require("../constants/constants.js")
let site_style_active = config.SITE_STYLE_ACTIVE;
const url_image_serch = config.URL_IMAGES_CUSTOMER1 + "dettagli-servizio.png";
const url_image_serch_go = config.URL_IMAGES_CUSTOMER1 + "dettagli-servizio.png";

const HeaderComponent1styleA_shop = () => {

  const dispatch = useDispatch();

  const itemsMenuLoginNotYet = [
    //{ text: 'Profilo', key: 'profilo' },
    //{ text: 'Impostazioni', key: 'configura' },
    { text: 'Login', key: 'login' },
  ]

  const itemsMenuLoginDone = [
    { text: 'Profilo', key: 'profilo' },
    { text: 'Ordini', key: 'ordini' },
    { text: 'Logout', key: 'logout' },
  ]

  const [avatarLoginTooltip, setAvatarLoginTooltip] = useState("");
  const [loggingIconTooltip, setLoggingIconTooltip] = useState("");
  const [carrelloIconTooltip, setCarrelloIconTooltip] = useState("");
  const [searchIconTooltip, setSearchIconTooltip] = useState("");

  const itemsMenuMain = [
    { text: 'Home', href: '/' },
    { text: 'Prodotti', href: '/prodotti' },
    //{ text: 'Servizi', href: '/servizi' },
    //{ text: 'Area Competenza', href: '/area-competenza' },
    { text: 'Brand', href: '/brands' },
    { text: 'Coupon', href: '/coupons' },
    { text: 'GiftCard', href: '/giftcards' },
    { text: 'Staff', href: '/staff' },
    { text: 'Chi siamo', href: '/chi-siamo' },
    { text: 'Contatti', href: '/contatti' },
  ]

  const itemsMenuMainUserLogged = [
    { text: 'Home', href: '/' },
    { text: 'Servizi', href: '/servizi' },
    { text: 'Staff', href: '/staff' },
    { text: 'Area Competenza', href: '/area-competenza' },
    { text: 'Chi siamo', href: '/chi-siamo' },
    { text: 'Contatti', href: '/contatti' },
    { text: 'Prodotti', href: '/prodotti' },
    { text: 'Ordini', href: '/ordini' },
  ]

  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const itemsCount = useSelector((state) => state.cart.itemsCount);
  const cartSubtotal = useSelector((state) => state.cart.cartSubtotal);

  const { categories } = useSelector((state) => state.getCategories);
  const { messageReceived } = useSelector((state) => state.adminChat);

  const [searchCategoryToggle, setSearchCategoryToggle] = useState("Tutte le categorie");
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  const url_customer_image_tel = config.URL_IMAGES_CUSTOMER + "tel-cust" + config.CUSTOMER_CODE + ".png";  // logo-cust0001.png 
  const url_customer_image_logo = config.URL_IMAGES_CUSTOMER1 + "logoShop-cust" + config.CUSTOMER_CODE + ".png";  // logoStudio-cust0001.png  
  const url_user_image_avatar = config.URL_IMAGES_CUSTOMER1 + "avatar-user1.png";

  const [showAlertSearchProdotto, setShowAlertSearchProdotto] = useState(false);
  const [searchCategory, setSearchCategory] = useState("");
  const [category, setCategory] = useState("");
  const [name, setName] = useState("");

  const handleSelectCategory = (event) => {
    setSearchCategory(event.target.value);
  };

  function closeAlertSearchProdotto() {
    setShowAlertSearchProdotto(false);
    setSearchCategory("Tutte le categorie")
    //navigate(1);
  }

  function isLoggato() {
    if (!userInfo || !userInfo.name) {
      console.log('[isLoggato] non loggato userInfo =', userInfo);
      return "none";
    } else {
      console.log('[isLoggato] loggato userInfo =', userInfo);
      return "block";
    }
  }

  useEffect(() => {
    dispatch(getCategories());
    console.log("[use] categories=", categories[1]?.name)
    setSearchCategory("tutte le categorie")
    //setSearchCategory(categories[0]?.name)
  }, [dispatch]);

  useEffect(() => {
    setLoggingIconTooltip("login");
    setAvatarLoginTooltip("");
    setCarrelloIconTooltip("carrello");
    setSearchIconTooltip("cerca");

    //console.log('[HEADER] userInfo =', userInfo);
    //console.log('[HEADER] userInfo.email =', userInfo.email);

    //let verLogin = userInfo.email;
    //if (userInfo.email === "" || userInfo.email === null || userInfo.email === false || !userInfo.email) {
    if (isLoggato() === 'none') {
      console.log('[HEADER] non loggato userInfo =', userInfo);
    } else {
      console.log('[HEADER] loggato userInfo =', userInfo);
      console.log('[HEADER] loggato userInfo.isAdmin =', userInfo.isAdmin);
      setLoggingIconTooltip(userInfo.name + " " + userInfo.lastName);
      setAvatarLoginTooltip(userInfo.name[0] + userInfo.lastName[0]);

      if (userInfo.isAdmin) {

        console.log('[HEADER] userInfo.isAdmin =', userInfo.isAdmin);

        var audio = new Audio("/audio/chat-msg.mp3");
        const socket = socketIOClient();
        socket.emit("admin connected with server", "Admin" + Math.floor(Math.random() * 1000000000000));
        socket.on("server sends message from client to admin", ({ user, message }) => {
          dispatch(setSocket(socket));
          //   let chatRooms = {
          //     fddf54gfgfSocketID: [{ "client": "dsfdf" }, { "client": "dsfdf" }, { "admin": "dsfdf" }],
          //   };
          dispatch(setChatRooms(user, message));
          dispatch(setMessageReceived(true));
          audio.play();
        })
        socket.on("disconnected", ({ reason, socketId }) => {
          //   console.log(socketId, reason)
          dispatch(removeChatRoom(socketId));
        })
        return () => socket.disconnect();
      }
    }

    //}, [userInfo.isAdmin])
  }, [setLoggingIconTooltip, setAvatarLoginTooltip, isLoggato])

  // CAMBIO STILE DEL SITO : goto subdomains
  // 
  //    switch stile: 
  //        CLASSIC   A       subdomain   classic.
  //        JAZZ      B       subdomain   jazz.
  //        MODERN    C       subdomain   modern.
  //        TIME      A       subdomain   time.
  // 
  const handleSelectStyle = (value) => {
    console.log('Style change in progress!')
    //console.log(value);
    site_style_active = value;
    //console.log(site_style_active)
    if (site_style_active === 'A') {
      //console.log('goto Classic style')
      window.location = "https://classic.mystudionline.it/"
    } else if (site_style_active === 'B') {
      //console.log('goto Jazz style')
      window.location = "https://jazz.mystudionline.it/"
    } else if (site_style_active === 'C') {
      //console.log('goto Modern style')
      window.location = "https://modern.mystudionline.it/"
    } else if (site_style_active === 'D') {
      //console.log('goto Time style')
      window.location = "https://time.mystudionline.it/"
    }
  }

  // CAMBIO STILE DEL SITO
  // 
  //    se config.ENABLE_SWITCH_STILE = true   => appare un combobox per la selezione dello stile e poi va al subdomain      
  //    se config.ENABLE_SWITCH_STILE = false  => non appare un combobox per la selezione dello stile       
  //
  /*
    function SwitchStile(props) {
      if (!props) {
        return null;
      }
      return (
      <NavDropdown title="Stile" id="collasible-nav-dropdown" onSelect={handleSelectStyle}>
          <NavDropdown.Item eventKey="A"> Classic </NavDropdown.Item>
          <NavDropdown.Item eventKey="B"> Jazz</NavDropdown.Item>
          <NavDropdown.Item eventKey="C"> Modern </NavDropdown.Item>
          <NavDropdown.Item eventKey="D"> Time </NavDropdown.Item>
      </NavDropdown>
      );
    }
  */

  const [applicativo, setApplicativo] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [email, setEmail] = useState("");
  const [telefonoCallFromSite, setTelefonoCallFromSite] = useState("");
  const [linkWhatsapp, setLinkWhatsapp] = useState("");
  const [linkFacebook, setLinkFacebook] = useState("");
  const [linkInstagram, setLinkInstagram] = useState("");
  const [linkTwitter, setLinkTwitter] = useState("");
  const [linkLinkedin, setLinkLinkedin] = useState("");
  const [urlSiteImageServer, setUrlSiteImageServer] = useState("");
  const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setRagioneSociale(data?.ragioneSociale);
      setEmail(data?.email);
      setTelefonoCallFromSite("tel:" + data?.telefonoCallFromSite)
      setLinkWhatsapp("https://wa.me/" + data?.linkWhatsapp);
      setLinkFacebook(data?.linkFacebook);
      setLinkInstagram(data?.linkInstagram);
      setLinkTwitter(data?.linkTwitter);
      setLinkLinkedin(data?.linkLinkedin);
      setUrlSiteImageServer(data?.urlSiteImageServer);
      setUrlCustomerImageServer(data?.urlCustomerImageServer);
      //setIsShopActive(data?.isShopActive === "Si" ? true : false);
      //setIsIconLoginActive(data?.isIconLoginActive === "Si" ? true : false);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      console.log(`data?.applicativo =`, data?.applicativo);
      console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      console.log(`data?.linkFacebook =`, data?.linkFacebook);
      console.log(`data?.linkInstagram =`, data?.linkInstagram);
      console.log(`data?.linkTwitter =`, data?.linkTwitter);
      console.log(`ragioneSociale =`, data?.ragioneSociale);
      console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
      console.log(`isShopActive =`, data?.isShopActive);
      console.log(`isIconLoginActive =`, data?.isIconLoginActive);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [ragioneSociale, setEmail, setUrlCustomerImageServer])


  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const [anchorElMenuUser, setAnchorElMenuUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleClickUserMenu = (wordkey) => {
    console.log("[handleClickUserMenu] wordkey=", wordkey);
    if (wordkey === "login") {
      //console.log("FAI login");
      //navigate(`/login`);
      window.location.assign('/login')
    } else
      if (wordkey === "profilo") {
        //console.log("FAI profilo userInfo=",userInfo._id);
        setAnchorElUser(null);
        navigate(`/admin/edit-user/${userInfo._id}`);
      } else
        if (wordkey === "configura") {
          console.log("FAI profilo userInfo=", userInfo._id);
          setAnchorElUser(null);
          navigate(`/admin/categories`);
        } else
          if (wordkey === "ordini") {
            console.log("FAI ordini userInfo=", userInfo._id);
            setAnchorElUser(null);
            //navigate(`/orders`);
            window.location.assign(`/orders/user/${userInfo._id}`)
          } else
            if (wordkey === "logout") {
              //console.log("FAI logout");
              dispatch(logout())
            }
  };

  const totaleItems = function (items) {
    console.log("isIconLoginActive =", isIconLoginActive)
    console.log("isShopActive =", isShopActive)
    let nrItems = 0;
    items.forEach(function (item, idx) {
      console.log(' item =', item)
      nrItems = nrItems + parseInt(item.quantity);

    })
    return nrItems
  }

  const clickIconSearchMainMenu = () => {
    setShowAlertSearchProdotto(!showAlertSearchProdotto);
  };

  return (

    <ThemeProvider theme={responsiveTheme}>

      <AppBar position="static">

        {/* 
        <Container maxWidth="xl">
        */}
        <Container maxWidth>

          <Toolbar disableGutters>

            <Box
              component="img"
              sx={{
                display: { xs: 'none', md: 'flex' },
                mr: 1,
                height: { xs: 40, md: 60 }
              }}
              alt="MPM webAgency"
              src={url_customer_image_logo}
            />

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>

              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>

              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: 'block', md: 'none' }, color: '#0000' }}
              >
                {itemsMenuMain.map((item) => (
                  <MenuItem key={item}>
                    <Button
                      key={item.text}
                      onClick={handleCloseNavMenu}
                      href={item.href}
                    >
                      <Typography
                        sx={{
                          p: 0,
                          my: 0,
                          color: 'white',
                          fontFamily: 'Sans-Serif',
                          fontWeight: 200,
                          fontSize: 14,
                        }}>
                        {item.text}
                      </Typography>
                    </Button>

                  </MenuItem>
                ))}

              </Menu>
            </Box>

            <Box
              component="img"
              sx={{
                display: { xs: 'flex', md: 'none' },
                ml: 2,
                height: { xs: 40, md: 60 }
              }}
              alt=""
              src={url_customer_image_logo}
            />

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

              {itemsMenuMain.map((item) => (

                <Button
                  key={item.text}
                  onClick={handleCloseNavMenu}
                  href={item.href}
                >
                  <Typography
                    sx={{
                      p: 0,
                      my: 0,
                      color: 'white',
                      fontFamily: 'Sans-Serif',
                      fontWeight: 200,
                      fontSize: 14,
                    }}>
                    {item.text}
                  </Typography>
                </Button>

              ))}

            </Box>

            <Box
              display={isShopActive === 'Si' ? "block" : "none"}
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 2,
              }}
            >

              <Stack
                sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0, }}
              >

                <Link to="/cart">
                  <Tooltip title={carrelloIconTooltip}>
                    <IconButton
                      sx={{
                        //display: isLoggato(),
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 1,
                      }}>
                      <ShoppingCartIcon fontSize="normal" />
                      <CartBadge
                        badgeContent={totaleItems(cartItems)}
                        color="success"
                      />
                    </IconButton>
                  </Tooltip>
                </Link>

                <Link onClick={clickIconSearchMainMenu}>
                  <Tooltip title={searchIconTooltip}>
                    <IconButton
                      sx={{
                        //display: isLoggato(),
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      }}>
                      <SearchSharpIcon fontSize="normal" />
                    </IconButton>
                  </Tooltip>
                </Link>

              </Stack>
            </Box>

            <Box
              display={isShopActive === 'Si' ? "block" : "none"}
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              }}>
              <Tooltip title={loggingIconTooltip}>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  {/* 
                    <Avatar alt={avatarLoginTooltip} src={url_user_image_avatar} />
                  */}
                  <Avatar sx={{ bgcolor: '#7bd0f4ff' }}>{avatarLoginTooltip}</Avatar>
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >

                {isLoggato() === 'none' ?

                  (
                    itemsMenuLoginNotYet.map((itemMenuLogin) => (
                      <MenuItem
                        value={itemMenuLogin.key}
                        onClick={() => handleClickUserMenu(itemMenuLogin.key)}
                      >
                        <Typography sx={{ textAlign: 'center' }}>{itemMenuLogin.text}</Typography>
                      </MenuItem>
                    ))
                  ) : (
                    itemsMenuLoginDone.map((itemMenuLogin) => (
                      <MenuItem
                        value={itemMenuLogin.key}
                        onClick={() => handleClickUserMenu(itemMenuLogin.key)}
                      >
                        <Typography sx={{ textAlign: 'center' }}>{itemMenuLogin.text}</Typography>
                      </MenuItem>
                    ))
                  )

                }

              </Menu>
            </Box>

          </Toolbar>

          <Box
            display={applicativo === 'myshop' && showAlertSearchProdotto ? "block" : "none"}
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
            }}>

            <Alert
              sx={{
                background: "#2f3337ff",
              }}
              minWidth='30ch'
              // background: "#212529",
              //sx={{ background: "#242526ff" }}
              //sx={{ background: "#3819c4ff" }}
              icon={false}
              dismissible
              onClose={() => closeAlertSearchProdotto()}
            >

              <Grid container
                spacing={1}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Grid
                  size={{ xs: 0, md: 1 }}
                >
                </Grid>

                <Grid
                  size={{ xs: 10, md: 12 }}
                >

                  <Stack
                    sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}
                  >

                    <FormControl
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 2,
                      }}
                    >
                      <InputLabel id="sel-categoria">categoria</InputLabel>
                      <Select
                        labelId="sel-categoria"
                        id="id-sel-categoria"
                        value={searchCategory}
                        label="Categorie"
                        onChange={handleSelectCategory}
                        defaultValue={"tutte le categorie"}
                        size='small'
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 300,
                          fontSize: { xs: 10, md: 12 },
                          minWidth: { xs: '14ch', md: '25ch' },
                        }}
                      >

                        <MenuItem
                          sx={{
                            fontFamily: 'Arial',
                            fontWeight: 300,
                            fontSize: { xs: 10, md: 12 },
                            minWidth: { xs: '14ch', md: '25ch' },
                          }}
                          key={"tutte le categorie"} value={"tutte le categorie"}
                        >
                          {"tutte le categorie"}
                        </MenuItem>

                        {categories.map(site => {
                          return (
                            <MenuItem key={site.name} value={site.name}
                              sx={{
                                fontFamily: 'Arial',
                                fontWeight: 300,
                                fontSize: 12,
                                minWidth: { xs: '14ch', md: '25ch' },
                              }}
                            >
                              {site.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>

                    <TextField id="id-ricercaprodotto" label="prodotto" variant="outlined"
                      size='small'
                      inputProps={{ style: { fontSize: 12 } }} 
                      InputLabelProps={{ style: { fontSize: 12 } }} 
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 2,
                        minWidth: { xs: '10ch', md: '25ch' }
                      }}
                      onChange={(event) => {
                        setName(event.target.value);
                      }}
                    />

                    <Link to={"/product-list/category/" + searchCategory}>
                      <Tooltip title={searchIconTooltip} arrow placement="right-end">
                        <IconButton
                          sx={{
                            alignSelf: 'center',
                            background: '#61c15cff'
                          }}
                          onClick={event => {
                            console.log("[click cercaGo] searchCategory=>", searchCategory + "<")
                            if (searchCategory !== " ") {
                              //setShowAlertSearchProdotto(!showAlertSearchProdotto)
                              navigate("/product-list/category/" + searchCategory)
                            }
                          }}
                        >
                          <SearchSharpIcon fontSize="normal" />
                        </IconButton>
                      </Tooltip>
                    </Link>

                  </Stack>

                </Grid>
              </Grid>

            </Alert>

          </Box>

        </Container>

      </AppBar>

    </ThemeProvider>

  );
};

export default HeaderComponent1styleA_shop;
